import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { makeQueryString } from "core/makeQueryString";
import { MachinesResponse } from "interfaces/machine";
import { AxiosContext } from "contexts/AxiosContext";

const STALE_TIME = 1000 * 60 * 15;

export const useMachinesQuery = (
  page = 1,
  pageSize = 10000
): UseQueryResult<MachinesResponse, unknown> => {
  const { axios } = useContext(AxiosContext)!;
  const queryString = makeQueryString({ page, size: pageSize });

  return useQuery({
    queryKey: ["machines", queryString],
    queryFn: async () => {
      const { data } = await axios.get<MachinesResponse>(
        `/machines${queryString}`
      );

      return data;
    },
    staleTime: STALE_TIME
  });
};
